'use strict';

// Account workspace — a balance-bearing ledger account, typed by AccountType and scoped to an entity (EntityName +
// IDEntity). Overview-only: Identity (+ AccountType FK card) · Scope · Balances.
module.exports = {
	Identifier: 'AccountWorkspace', Ordinal: 252,
	Entity: { Name: 'Account', IDField: 'IDAccount', Collection: 'Accounts', GUIDField: 'GUIDAccount' },
	Header: { Eyebrow: 'Account', Title: (r) => r.Name || `Account ${r.IDAccount}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/Account/List' },
	Tabs: [ { Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } } ],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'IDAccountType', Label: 'Account Type', Card: 'AccountType' }, { Key: 'Description', Label: 'Description', Wide: true } ] },
		{ Name: 'Scope', Fields: [ { Key: 'EntityName', Label: 'Entity' }, { Key: 'IDEntity', Label: 'Entity ID', Format: 'id' } ] },
		{ Name: 'Balances', Fields: [ { Key: 'Balance', Label: 'Balance', Format: 'currency' }, { Key: 'Pending', Label: 'Pending', Format: 'currency' } ] },
	],
};
